import {
  GetAllRefundsData,
  GetAllRefundsResponse,
} from "@services/models/Refund/GetAllRefundsModel";
import ConstantFunctions from "../../../utils/constants_functions";
import { useEffect, useState } from "react";
import { refundsServices } from "@services/apis/Refunds";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";

const RefundManagementMobile = () => {
  const constantFunctions = new ConstantFunctions();
  const [refunds, setRefunds] = useState<GetAllRefundsData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [refundId, setRefundId] = useState<string | undefined>(undefined);
  const navigate = useNavigate();

  const fetchRefundsData = async () => {
    try {
      setLoading(true);
      const response: GetAllRefundsResponse =
        await refundsServices.getAllRefunds();
      setRefunds(response.data);
    } catch (err: any) {
      setError("Failed to fetch cashier data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRefundsData();
  }, []);

  return (
    <div>
      {loading && (
        <>
          {[...Array(5)].map((_, index) => (
            <div
              key={`loading-${index}`}
              className="flex flex-row px-[16px] py-[12px] border-b border-border-table"
            >
              {[...Array(7)].map((_, i) => (
                <div key={i} className={i === 6 ? "w-[10%]" : "w-[15%]"}>
                  <Skeleton height={15} />
                </div>
              ))}
            </div>
          ))}
        </>
      )}
      {!loading && refunds.length === 0 && (
        <div className="text-center py-4 text-[10px] text-gray-500">
          No refund request found
        </div>
      )}
      {error && (
        <div className="text-center py-4 text-[10px] text-text-status-red">
          {error}
        </div>
      )}
      {refunds.length > 0 &&
        refunds.map((refund, index) => (
          <div
            className="flex flex-row justify-between items-center h-[75px] px-[12px] border-b border-border-table"
            key={index}
            onClick={() => {
              navigate("/refund-detail", {
                state: { refundId: refund.refundId },
              });
            }}
          >
            <div className="flex flex-col gap-[4px] w-1/3">
              <div className="flex items-center">
                <span className="text-text-base text-[12px] font-medium mr-1">
                  {refund.tradeId}
                </span>
                <span
                  className={`text-[10px] px-[6px] py-[1px] rounded ${
                    refund.tradeType === "B"
                      ? "bg-bg-status-green"
                      : "bg-bg-status-red"
                  } text-text-base`}
                >
                  {refund.tradeType}
                </span>
              </div>
              <p className="text-text-subtle text-[10px] font-medium">
                {constantFunctions.dateFormatInDDMMYY(refund.tradeTime)} -{" "}
                {constantFunctions.dateFormatInDDMMYY(refund.refundRequestTime)}
              </p>
            </div>
            <div className="flex flex-col gap-[4px] w-1/3">
              <div className="flex items-center">
                <div className="flex items-center">
                  <img
                    src={refund.cryptoCurrencyImage}
                    alt=""
                    className="h-[10px] w-[10px] mr-1"
                  />
                  <span className="text-[8px] font-medium text-text-base">
                    {refund.cryptoAmount?.toFixed(2)}
                  </span>
                </div>
                <span className="mx-1 text-[8px] font-medium text-text-base">
                  |
                </span>
                <div className="flex items-center">
                  <img
                    src={refund.fiatCurrencyImage}
                    alt=""
                    className="h-[10px] w-[10px] mr-1"
                  />
                  <span className="text-[8px] font-medium text-text-base">
                    {refund.fiatAmount?.toFixed(2)}
                  </span>
                </div>
              </div>
              <span className="text-[8px] font-medium text-text-base truncate">
                {refund.MOID}
              </span>
            </div>
            <div className="bg-bg-base rounded-sm p-[2px] text-[8px] text-text-status-green border border-text-status-green font-medium">
              Cx UTR: {refund.UTR}
            </div>
          </div>
        ))}
    </div>
  );
};

export default RefundManagementMobile;
